import React, { useMemo } from 'react';
import moment from 'moment';
import { useIntl, getLocale } from 'umi';
import { Row, Col, Card } from 'tea-component';
import TipContext from '@/pages/home/components/TipContextComponents/TipContext';
import BlockbusterGamesCard from '@/pages/intelligence/components/CardComponents/BlockbusterGamesCard';
import TopGameList from '../../components/TopGameList';
import {
  upperFrist,
  getBgImg,
  platImg,
  getValue,
} from '@/pages/intelligence/pages/MarketProfile/_util';
import { formatNum, formatPercentNum } from '@/pages/intelligence/utils/commonUtils';
import Loading from '@/pages/intelligence/components/Loading';
import NoData from '@/pages/intelligence/components/NoData';
import { getDetailGamePathCommon } from '@/pages/intelligence/utils/topchartsUtils';
// import CardContext from '@/pages/intelligence/pages/MarketProfile/components/CardContext';
import OverviewCard from '@intelligence/components/OverviewCard';

// import Appannie from '@/pages/intelligence/assets/svg/dataSource/app-annie.svg';
// import Mscience from '@/pages/intelligence/assets/svg/dataSource/mscience.svg';
// import NPD from '@/pages/intelligence/assets/svg/dataSource/npd.svg';
import DefaultImg from '@/pages/intelligence/assets/svg/flag/default.svg';
import xbox from '@/pages/intelligence/assets/svg/marketprofile/xbox.svg';
import playstation from '@/pages/intelligence/assets/svg/marketprofile/playstation.svg';
import nintendo from '@/pages/intelligence/assets/svg/marketprofile/nintendo.svg';

import './index.scss';

export default function TotalMarket(props: any) {
  const {
    summaryDataLoad,
    summaryTime,
    dataSource,
    part1Data,
    part2Data,
    part3Data,
    pcHasData,
    consoleHasData,
    newGameData,
    newGameLoad,
    newGameDate,
    topGameDataLoad,
    topGameTime,
    topGameTime2,
    topGameTime3,
    topGameTime4,
    topTotalGame,
    gotoStats,
    gotoGameDetailsPage,
  } = props || {};

  const { formatMessage } = useIntl();

  moment.locale(getLocale() === 'en-US' ? 'en' : 'zh-cn');

  const getHasSpace = () => {
    return getLocale() === 'en-US' ? ' ' : '';
  };

  // 将数据转换为卡片所需格式
  const formatLineData = (data: any) => ({
    dataType: 'month' as const,
    xAxisData: data?.xAxis,
    seriesData: data?.yAxis?.map((item: any) => item?.value),
  });

  const lineData1 = useMemo(() => formatLineData(part1Data), [part1Data]);
  const lineData2 = useMemo(() => formatLineData(part2Data), [part2Data]);
  const lineData3 = useMemo(() => formatLineData(part3Data), [part3Data]);

  const marketPerformanceData = [
    {
      // 新组件参数属性
      titleContent: `${formatMessage({ id: 'dbi_mobile' })}${getHasSpace()}${formatMessage({
        id: 'dbi_revenue_$',
      })}`,
      // titleIcon: 'appannie',
      titleIcon: dataSource,
      lineData: lineData1,
      baseIndicators: {
        indicatorsVal: part1Data.revenue === 0 ? '-' : formatNum(part1Data.revenue, true),
        rankVal: part1Data.rank,
        latestDate: moment(summaryTime).format('YYYY-MM'),
      },
      numArrowData: {
        numContent: formatPercentNum(part1Data.revenuePrecent),
        numSize: 'small',
        arrow: true,
        numColor: part1Data.revenuePrecent > 0 ? 'successColor' : 'errorColor',
        arrowColor: part1Data.revenuePrecent > 0 ? 'trendUp' : 'trendDown',
      },
      rankData: {
        numContent: part1Data.rankChange !== 0 ? Math.abs(part1Data.rankChange) : '-',
        numColor: 'grayColor',
        numSize: 'big',
        arrow: part1Data.rankChange !== 0,
        arrowColor: part1Data.rankChange > 0 ? 'grayUp' : 'grayDown',
      },
    },
    {
      // 新组件参数属性
      titleContent: `${formatMessage({ id: 'dbi_pc' })}${getHasSpace()}${formatMessage({
        id: 'dbi_revenue_$',
      })}`,
      titleIcon: 'mscience',
      lineData: lineData2,
      baseIndicators: {
        indicatorsVal: part2Data.revenue === 0 ? '-' : formatNum(part2Data.revenue, true),
        rankVal: part2Data.rank,
        latestDate: moment(summaryTime).format('YYYY-MM'),
      },
      numArrowData: {
        numContent: formatPercentNum(part2Data.revenuePrecent),
        numSize: 'small',
        arrow: true,
        numColor: part2Data.revenuePrecent > 0 ? 'successColor' : 'errorColor',
        arrowColor: part2Data.revenuePrecent > 0 ? 'trendUp' : 'trendDown',
      },
    },
    {
      // 新组件参数属性
      titleContent: `${formatMessage({ id: 'dbi_console' })}${getHasSpace()}${formatMessage({
        id: 'dbi_revenue_$',
      })}`,
      titleIcon: 'npd',
      lineData: lineData3,
      baseIndicators: {
        indicatorsVal: part3Data.revenue === 0 ? '-' : formatNum(part3Data.revenue, true),
        rankVal: part3Data.rank,
        latestDate: moment(summaryTime).format('YYYY-MM'),
      },
      numArrowData: {
        numContent: formatPercentNum(part3Data.revenuePrecent),
        numSize: 'small',
        arrow: true,
        numColor: part3Data.revenuePrecent > 0 ? 'successColor' : 'errorColor',
        arrowColor: part3Data.revenuePrecent > 0 ? 'trendUp' : 'trendDown',
      },
    },
  ];

  const BlockbusterGamesData = newGameData.map((item: any) => ({
    ...item,
    img: getBgImg(item),
    list: {
      entity_type: item?.entity_type,
      img: item.cover,
      gametitle: item.name,
      countryIcon: item.country_img || DefaultImg,
      text: item.publisher,
      icon: item.platform.split('|')?.map((obj: string) => {
        if (obj.toUpperCase() === 'PS') return playstation;
        if (obj.toUpperCase() === 'XBOX') return xbox;
        if (obj.toUpperCase() === 'NINTENDO') return nintendo;

        return '';
      }),
    },
    icon: platImg(item),
    desc: `${upperFrist(item?.chart_type || item?.chat_type)}${getValue(item)}`,
    title: `The description of the ${item.name}`,
    text: item.desc,
    linkUrl: getDetailGamePathCommon({
      entityType: item?.entity_type,
      gameId: item?.unified_id,
      tab: 'overview',
    }),
  }));

  return (
    <div className="dbi-marketoverview-total">
      <Card className="tabdetails-performance-summary">
        <Card.Body
          title={
            <div className="tabdetails-performance-felx">
              <span className="tabdetails-performance-felx-text">
                {formatMessage({ id: 'dbi_market_perf_sum' })}
              </span>
              <TipContext
                className="icon-top"
                tipText={formatMessage({ id: 'dbi_market_perf_sum_tip' })}
              />
            </div>
          }
        >
          <Row>
            {summaryDataLoad ? (
              <div style={{ width: '100%', height: 157 }}>
                <Loading content={formatMessage({ id: 'common_loading' })} />
              </div>
            ) : (
              marketPerformanceData.map((item: any, index: any) => {
                return (
                  <>
                    {/* 统一替换为新版 OverviewCard */}
                    <Col span={24 / marketPerformanceData.length} key={index}>
                      <OverviewCard
                        {...item}
                        moduleName="marketProfile"
                        onClickJump={() => gotoStats(item.titleContent)}
                      />
                    </Col>
                  </>
                );
              })
            )}
          </Row>
        </Card.Body>
      </Card>

      <Card className="tabdetails-top">
        <Card.Body
          title={
            <div className="tabdetails-gamehead">
              <div className="tabdetails-gamehead-title">
                <span className="tabdetails-gamehead-title-text">
                  {formatMessage({ id: 'dbi_market_blockbuster' })}
                </span>
                <TipContext
                  className="icon-top"
                  AWidth={430}
                  tipText={
                    <div style={{ maxWidth: '430px' }}>
                      {formatMessage({ id: 'dbi_market_blockbuster_mobile_tip' })}
                      <br />
                      <br />
                      {formatMessage({ id: 'dbi_market_blockbuster_pc_tip' })}
                      <br />
                      <br />
                      {formatMessage({ id: 'dbi_market_blockbuster_console_tip' })}
                      <br />
                    </div>
                  }
                />
              </div>
              <div className="tabdetails-gamehead-text">
                {newGameDate ? moment(newGameDate).format('MMM, YYYY') : null}
              </div>
            </div>
          }
        >
          <Row>
            {/* eslint-disable-next-line no-nested-ternary */}
            {newGameLoad ? (
              <div style={{ width: '100%', height: 417 }}>
                <Loading content={formatMessage({ id: 'common_loading' })} />
              </div>
            ) : newGameData?.length === 0 ? (
              <div
                className="context-num"
                style={{ height: 417, width: '100%', justifyContent: 'center' }}
              >
                <NoData title="No data under current selections." />
              </div>
            ) : (
              BlockbusterGamesData.map((item: any, index: any) => {
                return (
                  <Col
                    span={BlockbusterGamesData.length === 1 ? 12 : 24 / BlockbusterGamesData.length}
                    key={index}
                  >
                    <BlockbusterGamesCard
                      data={item}
                      onClick={() => gotoGameDetailsPage(item, 'overview')}
                      onDescClick={() => gotoGameDetailsPage(item, 'storeRank')}
                    />
                  </Col>
                );
              })
            )}
          </Row>
        </Card.Body>
      </Card>

      {topGameDataLoad ? (
        <Row className="tabdetails-rowtop">
          <Col span={24}>
            <Card style={{ height: 300, width: '100%' }}>
              <Loading content={formatMessage({ id: 'common_loading' })} />
            </Card>
          </Col>
        </Row>
      ) : (
        <Row className="tabdetails-rowtop">
          <Col span={12}>
            <TopGameList
              data={topTotalGame}
              source={dataSource}
              gameType="mobile"
              title={`Top 5 ${formatMessage({ id: 'dbi_mobile_games' })}`}
              time={moment(topGameTime).format('MMM, YYYY')}
              needTitle={true}
              segmentType={'total'}
              containerId={'mpTopGameListChartTotalMobile'}
              needChart={true}
            ></TopGameList>
          </Col>
          {pcHasData && (
            <Col span={12}>
              <TopGameList
                data={topTotalGame}
                source={dataSource}
                time={moment(topGameTime2).format('MMM, YYYY')}
                gameType="pc"
                title={`Top 5 ${formatMessage({ id: 'dbi_pc_games' })}`}
                needTitle={true}
                segmentType={'total'}
                containerId={'mpTopGameListChartTotalPc'}
                needChart={true}
              />
            </Col>
          )}
          {consoleHasData && (
            <Col span={12}>
              <TopGameList
                data={topTotalGame}
                source={dataSource}
                time={moment(topGameTime3).format('MMM, YYYY')}
                gameType="console"
                title={`Top 5 ${formatMessage({ id: 'dbi_console_games' })}`}
                needTitle={true}
                segmentType={'total'}
                containerId={'mpTopGameListChartTotalConsole'}
                needChart={true}
              />
            </Col>
          )}
          <Col span={12}>
            <TopGameList
              data={topTotalGame}
              source={dataSource}
              time={moment(topGameTime4).format('MMM, YYYY')}
              gameType="company"
              title={`Top 5 ${formatMessage({ id: 'dbi_imur_GC' })}`}
              needTitle={true}
              segmentType={'total'}
              containerId={'mpTopGameListChartTotalCompany'}
              needChart={true}
            />
          </Col>
        </Row>
      )}
    </div>
  );
}
